import React from 'react';
import { connect } from 'react-redux';
import { Jumbotron, Button, Row, Col, ControlLabel } from 'react-bootstrap';
import { Table, Tr, Td, Th, Thead } from 'reactable';
import moment from 'moment';
import _ from 'lodash';

import { gettext } from '../../../i18n/service.js';
import getCurLang from '../../../businessLogic/getCurLang.js';

class BillingDetailComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  paynow() {
    const { cards, detailbill } = this.props;
    const card = _.find(cards, { 'default': true });
    this.props.payBill(detailbill.id, card);
    //this.props.router.push('/pay');
  }

  render() {
    const { selectedWeek, workingWeeks, detailbill } = this.props;

    return (
      <div className="billing_detail">
        <Jumbotron>
          <ControlLabel><h3>{detailbill.month + " " + detailbill.year}</h3></ControlLabel>
          <Row className="center_flex">
            <Col sm={10}>
              <Col sm={12}>
                <ControlLabel className="billing_detail_label"><h4>Billing Details</h4></ControlLabel>
                {
                  detailbill.status === 'unpaid' ?
                    <Button className="pay_now" onClick={() => this.paynow()} bsStyle="primary">{gettext('BILL-PAY-NOW')}</Button>
                  : ''
                }
                <ControlLabel className="due_balance">
                  <h4>{getCurLang() === 'ar' ? "Due Balance " + detailbill.cost : "Due Balance " + detailbill.cost}</h4>
                </ControlLabel>

              </Col>
            </Col>
          </Row>
          <br />
          <Row className="center_flex">
            <Col sm={10}>
              <Col sm={12}>
                <div className="table_container">
                  <Table className="company_table table-fixedheader_bill">
                    <Thead>
                      <Th column={gettext('WEEK')}>
                        <span title={gettext('WEEK')}>{gettext('WEEK')}</span>
                      </Th>
                      <Th column={gettext('BILL-DELIVERED-ORDERS')}>
                        <span title={gettext('BILL-DELIVERED-ORDERS')}>{gettext('BILL-DELIVERED-ORDERS')}</span>
                      </Th>
                      <Th column={gettext('BILL-RETURNED-ORDERS')}>
                        <span title={gettext('BILL-RETURNED-ORDERS')}>{gettext('BILL-RETURNED-ORDERS')}</span>
                      </Th>
                      <Th column={gettext('BILL-CANCELED-ORDERS')}>
                        <span title={gettext('BILL-CANCELED-ORDERS')}>{gettext('BILL-CANCELED-ORDERS')}</span>
                      </Th>
                      <Th column={gettext('BILL-ADDITIONAL-PICKUP')}>
                        <span title={gettext('BILL-ADDITIONAL-PICKUP')}>{gettext('BILL-ADDITIONAL-PICKUP')}</span>
                      </Th>
                      <Th column={gettext('BILL-TOTAL-PRICE')}>
                        <span title={gettext('BILL-TOTAL-PRICE')}>{gettext('BILL-TOTAL-PRICE')}</span>
                      </Th>
                    </Thead>
                    {
                      workingWeeks.map((week, index) => {
                        return (
                          <Tr key={index}>
                            <Td column={gettext('WEEK')}>
                              {`Week ${week.value.week}(${moment.utc(week.value.startTime).format('MM/DD')}- ${moment.utc(week.value.endTime).format('MM/DD')})`}
                            </Td>
                            <Td column={gettext('BILL-DELIVERED-ORDERS')}>
                              {week.value.deliveredCount}
                            </Td>
                            <Td column={gettext('BILL-RETURNED-ORDERS')}>
                              {week.value.returnedCount}
                            </Td>
                            <Td column={gettext('BILL-CANCELED-ORDERS')}>
                              {week.value.canceledCount}
                            </Td>
                            <Td column={gettext('BILL-ADDITIONAL-PICKUP')}>
                              {
                                (week.value.additionalsCount ? week.value.additionalsCount : 0)
                              }
                            </Td>
                            <Td column={gettext('BILL-TOTAL-PRICE')}>
                              {
                                getCurLang() === 'ar' ?
                                  (week.value.totalCost)
                                  : (week.value.totalCost)
                              }
                            </Td>
                          </Tr>
                        );
                      })
                    }
                    <Tr className="total">
                      <Td column={gettext('WEEK')}>
                        {gettext('TOTAL')}
                      </Td>
                      <Td column={gettext('BILL-DELIVERED-ORDERS')}>
                        {detailbill.delivered}
                      </Td>
                      <Td column={gettext('BILL-RETURNED-ORDERS')}>
                        {detailbill.returned}
                      </Td>
                      <Td column={gettext('BILL-CANCELED-ORDERS')}>
                        {detailbill.canceled}
                      </Td>
                      <Td column={gettext('BILL-ADDITIONAL-PICKUP')}>
                        {detailbill.additionals}
                      </Td>
                      <Td column={gettext('BILL-TOTAL-PRICE')}>
                        {getCurLang() === 'ar' ? detailbill.cost : detailbill.cost}
                      </Td>
                    </Tr>
                  </Table>
                </div>
              </Col>
            </Col>
          </Row>
        </Jumbotron>
      </div>
    );
  }
}

BillingDetailComponent.propTypes = {

};

function mapStateToProps(state) {
  return {
    cards: state.appReducer.cards
  };
}

export default connect(
  mapStateToProps,
  null
)(BillingDetailComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/BillingDetailComponent.js